import gql from 'graphql-tag'

export const GET_CLIENT_QUERY = gql`
	query (
		$id: Int!
	) {
		getClient (
			data: {
				id: $id
			}
		) {
			id
			uid
			level {
				title
				level
			}
			fullName
			telNumber
			email
			address
			banned
			createdAt
			image
			clientType
			type
			locale
			referredBy {
				id
				uid
				fullName
				image
				email
				telNumber
				level {
					title
				}
			}
			coinsBalance
			totalEarnedCoins
			directReferralsCount
			totalNetworkPurchases
			totalPersonalPurchases
			updatedAt
			whatsappError
		}
	}
`;

export const GET_CLIENT_BALANCE_QUERY = gql`
	query (
		$id: Int!
	) {
		getClient (
			data: {
				id: $id
			}
		) {
			id
			level {
				title
				level
			}
			fullName
			telNumber
			email
			image
			coinsBalance
		}
	}
`;

export const GET_CLIENTS_PAGINATION_QUERY = gql`
	query (
		$skip: Int!,
		$take: Int!,
		$orderBy: [OrderByInput!]
		$query: String
	) {
		getClients (
			data: {
				orderBy: $orderBy
				pagination: {
					skip: $skip
					take: $take
				}
				query: $query
			}
		) {
			hasMore
			total
			items {
				id
				fullName
				telNumber
				email
				banned
				image
				clientType
				uid
				level {
					title
				}
				referredBy {
					id
					fullName
				}
				coinsBalance
				directReferralsCount
				whatsappError
			}
		}
	}
`
